
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import pageCom from "@/components/PageCom.vue";
import Vue from "vue";
export default Vue.extend({
  components: { pageCom },
  props: ["dtype", "choosed"],
  data() {
    return {
      items: [] as any[],
      search: "",
      pageSize: 6,
      total: 0,
      page: 1,
      currentChange: null as any,
    };
  },
  watch: {
    // choosed: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal) {
    //     console.log(this.choosed);
    //     const array: string[] = [];
    //     const table: any = this.$refs.table;
    //     if (this.choosed) {
    //       this.choosed.forEach((x: any) => {
    //         let value = this.items.find((y) => y.sid == x);
    //         if (value == null && x.sid) {
    //           value = this.items.find((y) => y.sid == x.sid);
    //         }
    //         if (value) {
    //           array.push(value);
    //           table.toggleRowSelection(value);
    //         }
    //       });
    //     } else {
    //       table.clearSelection();
    //     }
    //   },
    // },
  },
  methods: {
    async searchClick() {
      await this.getList();
    },
    async change(page: number, size: number) {
      this.page = page;
      this.pageSize = size;
      await this.getList();
    },
    handleSelectionChange(val: any) {
      this.$emit("selectChange", val);
    },
    initItem() {
      //
    },
    async getList(noFresh?: boolean) {
      const table: any = this.$refs.table;
      const array: string[] = [];
      if (noFresh && this.items.length > 0) {
        //
      } else {
        const ret = await DeviceRequestBill.GetGateways(
          this.search,
          this.page,
          this.pageSize
        );
        this.total = ret.total;
        this.items = ret.data;
      }
      this.$nextTick(() => {
        if (this.choosed && this.choosed.length > 0) {
          this.choosed.forEach((x: any) => {
            let value = this.items.find((y) => y.sid == x);
            if (value == null && x.sid) {
              value = this.items.find((y) => y.sid == x.sid);
            }
            if (value) {
              array.push(value);
              table.toggleRowSelection(value, true);
            }
          });
        } else {
          table.clearSelection();
        }
      });
    },
  },
});
